import { useState, useEffect } from "react";
import constate from "constate";

import { getToken, getUser } from "../utils/cookies";
import { getRolePermission } from "../apis/user";

const useRole = () => {
  //// blueprintRole: ["onlyView", "allowUpdate", "allowApprove"]
  const [appRole, setAppRole] = useState();

  useEffect(() => {
    if (getUser() !== undefined && getToken() !== undefined) {
      if (!appRole) {
        getRolePermission()
          .then((response) => {
            if (response["data"]["permissions"]?.["blueprintRole"]) {
              setAppRole(response["data"]["permissions"]["blueprintRole"]);
            } else {
              setAppRole("onlyView");
            }
          })
          .catch((error) => {
            console.error("Error while getRolePermission: ", error);
          });
      }
    }
  }, [appRole]);

  return { appRole };
};

export const [RoleProvider, useRoleContext] = constate(useRole);
